import React from "react";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import Map from "./Map";

type DealerMapProps = {
  lat: number;
  lng: number;
};

const DealersMap: React.FC<DealerMapProps> = ({ lat, lng }) => {
  if (!process.env.GATSBY_GOOGLE_MAP_API) {
    return null;
  }
  const render = (status: Status) => {
    return <h1>{status}</h1>;
  };

  return (
    <Wrapper apiKey={process.env.GATSBY_GOOGLE_MAP_API} render={render}>
      <Map lat={lat} lng={lng} />
    </Wrapper>
  );
};

export default DealersMap;
